import React from 'react'
import styles from './Offers.module.scss'



const Offers = () => {
    return (
        <ul className={styles.list}>
            <li className={styles.item}>
                <p className={styles.check}>&#10003;</p>
                <p className={styles.item_text}>Сделаем кровлю качественно, как для себя - с душой</p>
            </li>
            <li className={styles.item}>
                <p className={styles.check}>&#10003;</p>
                <p className={styles.item_text}>Расчет стоимости работ по телефону, <span>выезд на замер</span></p>
            </li>
            <li className={styles.item}>
                <p className={styles.check}>&#10003;</p>
                <p className={styles.item_text}>Опыт работы в области монтажа кровли <span> более&nbsp;20&nbsp;лет</span></p>
            </li>
        </ul>
    )
}

export default Offers